module.exports = __webpack_public_path__ + "img/stop@2x.a2d938eb.png";